export default "__VITE_PUBLIC_ASSET__068b9445__"